import operations from './descriptors/operations';
import marketing from './descriptors/marketing';
import products from './descriptors/products';
import team from './descriptors/team';

export const performanceDescriptors = {
    operations,
    marketing,
    products,
    team,
};

export default performanceDescriptors;
